'use client'

import { BANK_UNKNOWN } from '@/app/schemas/loan-comparator/financing.schema'

interface Props {
    bankName?: string
    loansCount: number
    importedCount: number
    signatureDate?: string
    onViewDocument?: () => void
    onReimport: () => void
    onManualEntry: () => void
    onHelpClick: () => void
}

export default function LoanPdfExtractSuccess({
    bankName,
    loansCount,
    importedCount,
    signatureDate,
    onViewDocument,
    onReimport,
    onManualEntry,
    onHelpClick,
}: Props) {
    const isBankKnown = !!bankName && bankName !== BANK_UNKNOWN
    const lead = isBankKnown ? `Offre ${bankName} lue.` : 'Votre offre de prêt a été lue.'
    // Un réimport du même document ne change plus rien : le diff est vide, autant taire le compte
    const details = [
        `${loansCount} ligne${loansCount > 1 ? 's' : ''} de prêt`,
        importedCount > 0
            ? `${importedCount} champ${importedCount > 1 ? 's' : ''} pré-rempli${importedCount > 1 ? 's' : ''}`
            : null,
    ]
        .filter(Boolean)
        .join(' et ')

    return (
        <>
            <div
                data-test="pdf-extract-success"
                role="status"
                aria-live="polite"
                tabIndex={-1}
                className="flex flex-col gap-2 rounded-2xl border border-green-800 bg-green-100 p-4 md:flex-row md:items-center md:gap-4 md:p-5"
            >
                <i className="fa-regular fa-circle-check text-2xl text-green-800" />

                <p className="m-0 min-w-0 flex-1 text-[15px] text-green-900">
                    <strong>{lead}</strong> {details}
                    {signatureDate ? ` · signature au ${signatureDate}` : ''}.
                </p>

                {onViewDocument && (
                    <button
                        type="button"
                        onClick={onViewDocument}
                        data-test="pdf-extract-view-document"
                        className="shrink-0 text-left text-[14px] font-semibold text-green-900 underline md:text-center"
                    >
                        Voir le document
                    </button>
                )}
            </div>

            <p className="m-0 mt-2 flex flex-wrap items-center gap-x-3 gap-y-1 text-[13px] text-pale/70">
                <button type="button" onClick={onReimport} data-test="pdf-extract-reimport" className="underline">
                    Importer un autre document
                </button>
                <button
                    type="button"
                    onClick={onManualEntry}
                    data-test="pdf-extract-manual-entry"
                    className="underline"
                >
                    Saisir manuellement
                </button>
                <button type="button" onClick={onHelpClick} data-test="pdf-extract-help" className="underline">
                    Comment ça marche
                </button>
            </p>
        </>
    )
}
